export const services = [
  {
    id: 's1',
    icon: 'ri-compass-3-line',
    titleKey: 'services.s1.title',
    descKey: 'services.s1.desc',
    tagKey: 'services.s1.tag',
    featured: false,
  },
  {
    id: 's2',
    icon: 'ri-shield-keyhole-line',
    titleKey: 'services.s2.title',
    descKey: 'services.s2.desc',
    tagKey: 'services.s2.tag',
    featured: true,
  },
  {
    id: 's3',
    icon: 'ri-broadcast-line',
    titleKey: 'services.s3.title',
    descKey: 'services.s3.desc',
    tagKey: 'services.s3.tag',
    featured: false,
  },
  {
    id: 's4',
    icon: 'ri-line-chart-line',
    titleKey: 'services.s4.title',
    descKey: 'services.s4.desc',
    tagKey: 'services.s4.tag',
    featured: false,
  },
];